<template>
  <nav
    class="top-0 absolute z-20 w-full p-2 navbar-expand-lg shadow text-white"
  >
    <div class="pr-4 flex items-center">
      <!-- toggler -->
      <span class="md:hidden block">
        <button-icon color="text-gray-500" @click="toggleSidebar"
          ><i class="fas fa-bars"
        /></button-icon>
      </span>
      <!-- logo -->
      <div class="ml-1 md:ml-4">
        <router-link to="/" class="inline-block mr-4 whitespace-no-wrap"
          ><logo
        /></router-link>
      </div>
      <!-- content block -->

      <div class="hidden md:flex lg:w-auto lg:static justify-start">
        <div class="relative flex items-center mr-2">
          <input
            ref="focusMdSearch"
            type="text"
            class="bg-gray-800 text-sm rounded-full w-32 lg:w-64 px-4 pl-8 py-1 outline-none focus:outline-none"
            placeholder="Search (press '/' to focus)"
            v-model="searchText"
            @keypress="handleSearch"
          />
          <div class="absolute top-0">
            <i class="fas fa-search text-gray-500 w-4 mt-2 ml-2"></i>
          </div>
        </div>
        <router-link to="/celebs">
          <button-base :borderStyle="'border-dashed'" :background="'black'"
            ><i class="fab fa-airbnb"></i> Celebs</button-base
          >
        </router-link>
      </div>
      <!-- expand space -->
      <div class="flex-1" />
      <ul class="flex items-center pl-0">
        <li class="inline mr-4 hidden md:block">
          <router-link to="/movies" class=" text-white hover:underline"
            ><small>Explore </small> <b>MOVIES</b></router-link
          >
        </li>
        <li class="inline mr-2 hidden md:block">
          <button-base :background="'black'"
            ><i class="fa fa-plus-circle" /> create list
          </button-base>
        </li>
        <li class="inline mr-3 md:hidden block">
          <button-icon color="text-gray-500" @click="openHiddenSearch"
            ><i class="fas fa-search"
          /></button-icon>
        </li>
        <li class="inline">
          <button-base :background="'black'">sign in</button-base>
        </li>
      </ul>
    </div>
  </nav>
  <!-- Search overlay -->
  <div
    class="absolute w-full z-50 transition delay-150 duration-300 ease-in-out block md:hidden"
    style="height: 60px"
    :class="[openSearch ? 'top-0' : '-top-20']"
  >
    <div
      class="relative bg-gray-800 text-white w-full h-full flex items-center px-3"
    >
      <!-- eslint-disable-next-line vue/valid-v-on -->
      <input
        type="text"
        class="bg-gray-800 text-sm w-full flex-1 px-4 py-1 outline-none focus:outline-none"
        placeholder="Search"
        ref="focusSearch"
        v-model="searchText"
        @keypress="handleSearch"
      />
      <div class="px-2" @click="closeHiddenSearch">
        <i class="fas fa-times fa-2x text-gray-500 w-4 mt-2 ml-2"></i>
      </div>
    </div>
  </div>
  <!-- sidebar -->
  <sidebar-base :show="showSidebar" @closeSidebar="toggleSidebar">
    <ul v-for="(list, index) in lists" :key="index" class="pl-8">
      <li class="block uppercase my-3 text-white">
        <router-link
          v-if="list.path"
          :to="{ path: list.path }"
          class="hover:underline"
          exact-active-class="underline"
          >{{ list.title }}</router-link
        >
        <p v-else>{{ list.title }}</p>
      </li>
    </ul>
  </sidebar-base>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import SidebarBase from "@/components/Sidebar/SidebarBase.vue";
import Logo from "./Logo";
export default {
  name: "navbar",
  components: {
    SidebarBase,
    Logo
  },
  setup() {
    const router = useRouter();
    let showSidebar = ref(false);
    let openSearch = ref(false);
    let focusSearch = ref();
    let focusMdSearch = ref();
    let searchText = ref("");
    let lists = ref([
      { title: "Celebs", path: "/celebs" },
      { title: "Explore Movies", path: "/movies" },
      { title: "Create List", path: null }
    ]);

    let toggleSidebar = () => {
      showSidebar.value = !showSidebar.value;
    };
    let openHiddenSearch = () => {
      openSearch.value = !openSearch.value;

      focusSearch.value.focus();
    };
    let closeHiddenSearch = () => {
      openSearch.value = !openSearch.value;
      searchText.value = "";
      focusSearch.value.blur();
    };

    onMounted(() => {
      window.addEventListener("keydown", function(e) {
        if (e.code === "Slash") {
          focusMdSearch.value.focus();
        }
      });
    });

    const handleSearch = e => {
      // e.preventDefault();
      if (e.key === "Enter" && searchText.value !== "") {
        router.push({
          path: "/search",
          name: "Search",
          query: {
            q: searchText.value
          }
        });
      }
    };

    return {
      showSidebar,
      toggleSidebar,
      lists,
      searchText,
      handleSearch,
      openHiddenSearch,
      closeHiddenSearch,
      openSearch,
      focusSearch,
      focusMdSearch
    };
  }
};
</script>

<style lang="scss" scoped>
nav {
  background: rgba(255, 255, 255, 0.05);
  height: 60px;
}
</style>
